import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { SelectionSingleType } from '../types';
import css from './Breadcrumbs.scss';

type Props = {
	selection: SelectionSingleType;
};

const Breadcrumbs = (props: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleIsOpen = () => setIsOpen(v => !v);

	useEffect(() => {
		setIsOpen(false);
	}, [props.selection.id]);

	return (
		<div className={cn(css.breadcrumbs, { [css.open]: isOpen })}>
			{/* @ts-expect-error ts-migrate FIXME */}
			{props.selection.editableModeProps.inheritance.parent.slice(-3).map(parent => (
				<div
					className={css.crumb}
					key={`crumb-parent-${parent.path}`}
					onClick={event => {
						toggleIsOpen();
						const selected = document.getElementById(props.selection.id);
						// @ts-expect-error ts-migrate FIXME
						const clicked = selected.closest(`[data-path="${parent.path}"]`);

						// @ts-expect-error ts-migrate FIXME
						clicked.dispatchEvent(
							new MouseEvent(
								'mousedown',
								// @ts-expect-error ts-migrate FIXME
								Object.assign(event, { bubbles: true, metaKey: true, ctrlKey: true })
							)
						);
					}}
				>
					{parent.name}
				</div>
			))}
			<div className={css.crumb} onClick={toggleIsOpen}>
				{props.selection.uiConfig.editorProps.name}
			</div>
		</div>
	);
};

export default Breadcrumbs;
